<template>
  <div class="blood-chart">
    <div>
      <Line class="blood-chart-inner" :data="filteredChartData" :options="chartOptions"  />
    </div>
  </div>
  <div class="blood-calendar__bottom radio-wrap">
      <label for="radio02-01" class="">
          <input type="radio" id="radio02-01" class="agree-" name="agree02" value="all" v-model="selectedDataset"> 
          <span class="radio-btn"></span>
          <p>전체</p> 
      </label>
      <label for="radio02-02" class="">
          <input type="radio" id="radio02-02" class="agree-" name="agree02" value="item01" v-model="selectedDataset">
          <span class="radio-btn"></span> 
          <p>{{chartDataSet.type == 'BP' ? '수축기혈압' : chartDataSet.type == 'BS' ? '식전' : 'BMI'}}</p> 
      </label>
      <label for="radio02-03" class="" v-if="chartDataSet.type != 'BM'">
          <input type="radio" id="radio02-03" class="agree-" name="agree02" value="item02" v-model="selectedDataset">
          <span class="radio-btn"></span> 
          <p>{{chartDataSet.type == 'BP' ? '이완기혈압' : chartDataSet.type == 'BS' ? '식후' : ''}}</p> 
      </label>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, LinearScale, CategoryScale, ChartDataLabels);

export default {
  props: {
    chartDataSet: {}
  },
  components: {
    Line,
  },
  data() {
    return {
      isMobile: false, // 모바일 여부를 체크할 변수
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'HealthInfo 1',
            backgroundColor: 'transparent',
            // borderColor: '#7d1928',
            borderColor: this.getMainColor(),
            pointBackgroundColor: '#fff',
            data: [],
            fill: false,
            tension: 0.4,
            borderWidth: 1,  // 선의 두께
            pointRadius: 7,  // 포인트 크기
            pointBorderWidth: 3,  // 포인트의 테두리 두께
            datalabels: {
              anchor: 'end',
              align: (context) => {
                return 'end'; 
              },
              formatter: (value) => value,
              color: 'white',
              backgroundColor: this.getMainColor(),
              borderRadius: 3,
              padding: {
                top: 4,
                bottom: 2,
                left: 8,
                right: 8,
              },
              width: 200,
              font: {
                size: 16,
                weight: '700',
              },
            },
          },
          {
            label: 'HealthInfo 2',
            backgroundColor: 'transparent',
            borderColor: this.getSubColor(),
            pointBackgroundColor: '#fff',
            data: [],
            fill: false,
            tension: 0.4,
            borderWidth: 1,  // 선의 두께
            pointRadius: 7,  // 포인트 크기
            pointBorderWidth: 3,  // 포인트의 테두리 두께
            datalabels: {
              anchor: 'end',
              align: (context) => {
                return 'start'; 
              },
              formatter: (value) => value,
              color: 'white',
              backgroundColor: this.getSubColor(),
              borderRadius: 3,
              padding: {
                top: 4,
                bottom: 2,
                left: 8,
                right: 8,
              },
              offset: 20,
              font: {
                size: 16,
                weight: '700',
              },
            },
          },
        ],
      },
      chartOptions: this.getChartOptions(), // 초기 차트 옵션
      selectedDataset: 'all',
      maxValue: 200,
    };
  },
  mounted() {
    this.updateMobileStatus(); // 초기 모바일 상태 확인
    window.addEventListener('resize', this.updateMobileStatus); // 리사이즈 이벤트 리스너 등록
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateMobileStatus); // 리사이즈 이벤트 리스너 제거
  },
  methods: {
    getMainColor() {
      const hostNm = this.$store.state.hospStore.hostNm;
      if (hostNm === '대동맥혈관병원') {
        return '#7D1928';
      } else if (hostNm === '뇌혈관병원') {
        return '#4B287D';
      } else{
        return '#AF3C64';
      }
    },
    getSubColor() {
      const hostNm = this.$store.state.hospStore.hostNm;
      if (hostNm === '대동맥혈관병원') {
        return '#09847D';
      } else if (hostNm === '뇌혈관병원') {
        return '#C55337';
      } else{
        return '#09847D';
      }
    },
    updateMobileStatus() {
      this.isMobile = window.innerWidth < 768; // 모바일 기준: 768px 이하
      this.chartOptions = this.getChartOptions(); // 차트 옵션 업데이트
    },
    getChartOptions() {
      if (this.isMobile) {
        return {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 0,
              right: 30, // 모바일에서의 오른쪽 패딩
              bottom: 0,
              left: 0,
            },
          },
          scales: {
            y: {
              min: 0,
              max: this.maxValue,
              title: {
                display: true,
                text: 'none',
                padding: {
                  top: -13,
                  right: -50,
                },
                font: {
                  size: 0,
                  weight: '400',
                },
              },
              ticks: {
                callback: function(value) {
                  const grid = [0, 40, 80, 120, 160, 200]
                  return grid.includes(value) ? value : '';
                },
                padding: 18, // 모바일에서의 ticks 패딩
                font: {
                  size: 14,
                  weight: '400',
                },
              },
              grid: {
                display: true,
                drawBorder: false,
                color: (context) => {
                  const grid = [0, 40, 80, 120, 160, 200]
                  return grid.includes(context.tick.value) ? 'rgba(0, 0, 0, 0.1)' : 'transparent';
                },
              },
            },
            x: {
              ticks: {
                padding: 10, // 모바일에서의 x축 ticks 패딩
                font: {
                  size: 16,
                  weight: '500',
                },
              },
              grid: {
                display: false,
                drawBorder: false,
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
            datalabels: {
              display: true,
            },
          },
          elements: {
            point: {
              radius: 7,  // 포인트 크기
              hoverRadius: 7,  // 호버 시 포인트 크기 (변경되지 않도록 설정)
              borderWidth: 3,  // 포인트의 테두리 두께
              hoverBorderWidth: 3,  // 호버 시 테두리 두께 (변경되지 않도록 설정)
              backgroundColor: '#fff',  // 포인트 배경색
              hoverBackgroundColor: '#fff',  // 호버 시 배경색 (변경되지 않도록 설정)
              pointStyle: 'rectRot',  // 마름모 형태
            },
          },
        };
      } else {
        return {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 0,
              right: 115, // PC에서의 오른쪽 패딩
              bottom: 0,
              left: 0,
            },
          },
          scales: {
            y: {
              min: 0,
              max: this.maxValue,
              title: {
                display: true,
                text: 'none',
                padding: {
                  top: -10,
                  right: -100,
                },
                font: {
                  size: 0,
                  weight: '400',
                },
              },
              ticks: {
                callback: (value) => {
                  const grid = [0, 40, 80, 120, 160, 200]
                  return grid.includes(value) ? value : '';
                },
                padding: 50, // PC에서의 ticks 패딩
                font: {
                  size: 16,
                  weight: '400',
                },
              },
              grid: {
                display: true,
                drawBorder: false,
                color: (context) => {
                  const grid = [0, 40, 80, 120, 160, 200]
                  return grid.includes(context.tick.value) ? 'rgba(0, 0, 0, 0.1)' : 'transparent';
                },
              },
            },
            x: {
              ticks: {
                padding: 20, // PC에서의 x축 ticks 패딩
                font: {
                  size: 18,
                  weight: 'bold',
                },
              },
              grid: {
                display: false,
                drawBorder: false,
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
            datalabels: {
              display: true,
            },
          },
          elements: {
            point: {
              radius: 7,  // 포인트 크기
              hoverRadius: 7,  // 호버 시 포인트 크기 (변경되지 않도록 설정)
              borderWidth: 3,  // 포인트의 테두리 두께
              hoverBorderWidth: 3,  // 호버 시 테두리 두께 (변경되지 않도록 설정)
              backgroundColor: '#fff',  // 포인트 배경색
              hoverBackgroundColor: '#fff',  // 호버 시 배경색 (변경되지 않도록 설정)
              pointStyle: 'rectRot',  // 마름모 형태
            },
          },
        };
      }
    },
    calcGrid(){
      const step = this.maxValue / 5
      const grid = Array.from({ length: 5 }, (_, i) => Math.floor((i + 1) * step))
      grid.unshift(0)
      return grid
    }
  },
  computed: {
    filteredChartData() {
      if (this.selectedDataset === 'item01') {
        return {
          ...this.chartData,
          datasets: [this.chartData.datasets[0]]
        }
      } else if (this.selectedDataset === 'item02') {
        return {
          ...this.chartData,
          datasets: [this.chartData.datasets[1]]
        }
      } else {
        return {
          ...this.chartData,
          datasets: [this.chartData.datasets[0], this.chartData.datasets[1]]
        }
      }
    },
  },
  watch: {
    chartDataSet: {
      handler(newData) {
        let newLabels = newData.labels || [];
        let newRecord1 = newData.record1 || [];
        let newRecord2 = newData.record2 || [];
        let concatArr = newRecord1.concat(newRecord2)
        // const max = concatArr.length > 0 ? parseInt(Math.max(...concatArr) + (Math.max(...concatArr) * 0.1)) : 200

        this.chartData.labels = newLabels
        this.chartData.datasets[0].data = newRecord1
        this.chartData.datasets[1].data = newRecord2
        // this.maxValue = max
        // this.chartOptions = this.getChartOptions(); // 차트 옵션 업데이트
      },
      deep: true,
      immediate: true
    }
  },
};
</script>

<style scoped>
</style>
